<template>
	<ui-modal @toggle="emit('toggle')">
		<Head title="Fusion de contacts" />
		<form method="post" @submit.prevent="handleSubmit" class="flex flex-col gap-2">
			<ui-title textSize="big" textPosition="left" class="lg:col-span-2 text-slate-700">
				<template v-slot:text>
					<p>Fusionner deux contacts</p>
				</template>
			</ui-title>

			<div class="flex flex-col gap-2">
				<div class="flex items-center justify-between gap-2 border-b-2 pb-4">
					<h3 class="text-xl font-bold grow w-full">Contact actuel</h3>
					<div></div>
					<form-search type="contact" @select="fusedContact = $event" :history="true" :excludedIds="[contact.id]"></form-search>
				</div>

				<div class="flex items-center justify-between gap-2" v-if="fusedContact">
					<p>Le contact de cette colonne sera conservé.</p>
					<div></div>
					<p><i class="fas fa-warning text-red-700"></i> Le contact de cette colonne sera supprimé !</p>
				</div>
				<div class="flex flex-col gap-2" v-if="fusedContact">
					<ui-fuse-field
						:left="contact?.targeted ? 'Ciblé' : 'Non ciblé'"
						:right="fusedContact?.targeted ? 'Ciblé' : 'Non ciblé'"
						placeholder="Ciblé"
						@toggle="fuseSwap.targeted = $event" />
					<!-- FIRST NAME -->
					<ui-fuse-field
						:left="contact?.first_name"
						:right="fusedContact?.first_name"
						placeholder="Prénom"
						@toggle="fuseSwap.first_name = $event" />

					<!-- LAST NAME -->
					<ui-fuse-field
						:left="contact?.last_name"
						:right="fusedContact?.last_name"
						placeholder="Nom"
						@toggle="fuseSwap.last_name = $event" />

					<!-- STATUS -->
					<ui-fuse-field
						:left="contact?.status?.name"
						:right="fusedContact?.status?.name"
						placeholder="Statut"
						@toggle="fuseSwap.status = $event" />

					<!-- E-MAIL -->
					<ui-fuse-field
						:left="contact?.email"
						:right="fusedContact?.email"
						placeholder="Adresse e-mail"
						@toggle="fuseSwap.email = $event" />

					<!-- PHONE -->
					<ui-fuse-field :left="contact?.phone" :right="fusedContact?.phone" placeholder="Téléphone" @toggle="fuseSwap.phone = $event" />

					<!-- ADDRESS -->
					<ui-fuse-field
						:left="contact?.address"
						:right="fusedContact?.address"
						placeholder="Adresse"
						@toggle="fuseSwap.address = $event" />

					<!-- POSTAL_CODE -->
					<ui-fuse-field
						:left="contact?.postal_code"
						:right="fusedContact?.postal_code"
						placeholder="Code postal"
						@toggle="fuseSwap.postal_code = $event" />

					<!-- CITY -->
					<ui-fuse-field :left="contact?.city" :right="fusedContact?.city" placeholder="Ville" @toggle="fuseSwap.city = $event" />

					<!-- PRO_ID -->
					<ui-fuse-field :left="contact?.pro_id" :right="fusedContact?.pro_id" placeholder="RPPS" @toggle="fuseSwap.pro_id = $event" />

					<!-- ADELI -->
					<ui-fuse-field :left="contact?.adeli" :right="fusedContact?.adeli" placeholder="ADELI" @toggle="fuseSwap.adeli = $event" />

					<!-- POTENTIAL -->
					<ui-fuse-field
						:left="contact?.potential"
						:right="fusedContact?.potential"
						placeholder="Potentiel d'installation"
						@toggle="fuseSwap.potential = $event" />

					<!-- OBJECTIVE -->
					<ui-fuse-field
						:left="contact?.objective"
						:right="fusedContact?.objective"
						placeholder="Objectif de visite quadrimestriel"
						@toggle="fuseSwap.objective = $event" />

					<!-- COMMENT -->
					<ui-fuse-field
						:left="contact?.comment"
						:right="fusedContact?.comment"
						placeholder="Commentaire"
						@toggle="fuseSwap.comment = $event" />

					<!-- SCHEDULE -->
					<ui-fuse-field
						:left="contact?.schedule"
						:right="fusedContact?.schedule"
						placeholder="Horaires"
						@toggle="fuseSwap.schedule = $event" />

					<!-- SKILLS -->
					<!-- Loop on contact.skills (null check) and implode (with ', ') the name properties, same for fusedContact.skills -->
					<ui-fuse-field
						:left="contact?.skills?.map((skill) => skill.name).join(', ')"
						:right="fusedContact?.skills?.map((skill) => skill.name).join(', ')"
						placeholder="Compétences"
						@toggle="fuseSwap.skills = $event" />

					<!-- COMPETITORS -->
					<!-- Same as Skills for the presentation -->
					<ui-fuse-field
						:left="contact?.competitors?.map((competitor) => competitor.name).join(', ')"
						:right="fusedContact?.competitors?.map((competitor) => competitor.name).join(', ')"
						placeholder="Concurrents"
						@toggle="fuseSwap.competitors = $event" />

					<!-- ACTIVITIES -->
					<!-- Same as Skills & Competitors for the presentation -->
					<ui-fuse-field
						:left="contact?.activities?.map((activity) => activity.name).join(', ')"
						:right="fusedContact?.activities?.map((activity) => activity.name).join(', ')"
						placeholder="Activités"
						@toggle="fuseSwap.activities = $event" />

					<!-- SERVICE -->
					<ui-fuse-field
						:left="contact?.service"
						:right="fusedContact?.service"
						placeholder="Service"
						@toggle="fuseSwap.service = $event" />

					<!-- DR_ID -->
					<ui-fuse-field
						:left="contact?.dr?.length > 0 ? contact?.dr?.length + ' entrée(s)' : null"
						:right="fusedContact?.dr?.length > 0 ? fusedContact?.dr?.length + ' entrée(s)' : null"
						placeholder="Nombre de DR"
						@toggle="fuseSwap.dr = $event" />

					<!-- INFOS -->
					<ui-fuse-field
						:left="
							contact.infos?.communication
								?.map((communicationType) => usePage().props.str.statuses.find((element) => element.slug == communicationType)?.name)
								.join(', ')
						"
						:right="
							fusedContact?.infos?.communication
								?.map((communicationType) => usePage().props.str.statuses.find((element) => element.slug == communicationType)?.name)
								.join(', ')
						"
						placeholder="Communication"
						@toggle="fuseSwap.infos.communication = $event" />

					<ui-fuse-field
						v-if="usePage().props.str.statuses.filter((status) => status.type == 'visit').length > 0"
						:left="
							contact.infos?.visit
								?.map((visitType) => usePage().props.str.statuses.find((element) => element.slug == visitType)?.name)
								.join(', ')
						"
						:right="
							fusedContact?.infos?.visit
								?.map((visitType) => usePage().props.str.statuses.find((element) => element.slug == visitType)?.name)
								.join(', ')
						"
						placeholder="Type de visite"
						@toggle="fuseSwap.infos.visit = $event" />

					<!-- STRUCTURES -->
					<ui-fuse-field
						:left="contact?.structures?.map((structure) => structure.name).join(', ')"
						:right="fusedContact?.structures?.map((structure) => structure.name).join(', ')"
						placeholder="Structures"
						@toggle="fuseSwap.structures = $event" />

					<!-- HISTORIQUE -->
					<!-- We're not listing the full history, but the number of entries in contact.logs or fusedContact.logs -->
					<ui-fuse-field
						:left="contact?.logs?.length > 0 ? contact?.logs?.length + ' entrée(s)' : null"
						:right="fusedContact?.logs?.length > 0 ? fusedContact?.logs?.length + ' entrée(s)' : null"
						placeholder="Historique"
						@toggle="fuseSwap.history = $event" />
				</div>

				<form-validation-errors class="lg:col-span-2"></form-validation-errors>
			</div>

			<ui-button
				class="col-span-2 mt-3 font-bold border-2"
				position="center"
				@click.prevent="handleSubmit"
				:loading="loading"
				v-if="fusedContact">
				<template v-slot:text>Valider</template>
			</ui-button>
		</form>
	</ui-modal>
</template>

<script setup>
	import { ref, reactive, onMounted } from 'vue';
	import { router, useForm, usePage } from '@inertiajs/vue3';

	// Define props
	const props = defineProps({
		statuses: {
			type: Object,
			default: null,
		},
		contact: {
			type: Object,
			default: null,
		},
	});

	// Define emits
	const emit = defineEmits(['toggle']);

	// Reactive state
	const loading = ref(false);
	const formLoading = ref(false);
	const errors = ref(null);
	const fusedContact = ref(null);

	// Keep track of which fields to keep (false = left/current, true = right/searched)
	const fuseSwap = useForm({
		first_name: false,
		last_name: false,
		role: false,
		email: false,
		phone: false,
		secondary_email: false,
		secondary_phone: false,
		address: false,
		postal_code: false,
		city: false,
		pro_id: false,
		adeli: false,
		potential: false,
		targeted: false,
		objective: false,
		comment: false,
		schedule: false,
		skills: false,
		competitors: false,
		activities: false,
		status: false,
		target: false,
		service: false,
		dr: false,
		infos: {
			communication: false,
			visit: false,
		},
		structures: false,
		history: false,
	});

	function handleSubmit() {
		formLoading.value = true;
		fuseSwap.post(route('contacts.fusion', { contact: props.contact.id, fusion: fusedContact.value.id }), {
			onSuccess: () => {
				emit('toggle');
				formLoading.value = false;
			},
		});
	}

	// Lifecycle hooks
	onMounted(() => {});
</script>
